import { forwardPage, forwardPageSync } from './forwardPage'
import { ICallback } from './interface'

/**
 * 唤起原生壳子资金账号登录 <br>
 * 在调起壳子的资金账号登录之后，会关闭当前的webview，但壳子不会回调调用传入的函数<br>
 * 若手机号没有登录，则先唤起手机号登录窗口，然后是资金账号登录窗口<br>
 * 因此，目前只能使用 viewAppear() 或直接使用 LightJSBridge.onPageAppear = () => {}
 *
 * @param {ICallback} { success, fail, complete }
 */
function evokeFundAccountLoginSync({ success, fail, complete }: ICallback) {
  const pageId = '1-21-1'
  // 自动手机号登录后掉起资金账号登录
  const param = 'login_flag=2&next_activity_id=1-21-1'

  forwardPageSync({ pageId, param, success, fail, complete })
}

/**
 * 唤起原生壳子资金账号登录 <br>
 * 一个异步接口，支持 Promise 化使用
 * @returns
 */
function evokeFundAccountLogin() {
  const pageId = '1-21-1'
  // 自动手机号登录后掉起资金账号登录
  const param = 'login_flag=2&next_activity_id=1-21-1'

  return forwardPage({ pageId, param })
}

export { evokeFundAccountLogin, evokeFundAccountLoginSync }
